/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
import { FitinsurAPI } from 'utils';

function handleInitialAdjustments({
  groupQuestions,
  setEconomicGroup,
  setInitialEconomicGroup,
  economicGroupSectionHierarchy,
  isEconomicGroup
}) {
  const hierarchyGroups = [];
  
  if (!economicGroupSectionHierarchy) return;

  for (const economicGroup of economicGroupSectionHierarchy) {

    const economicGroups = [];
    for (const group of economicGroup.economicGroupRelationships) {
      const groupQuestionAnswer = group.questions;

      let cloneEconomicGroup, groupObject = {};
  
      try {
        cloneEconomicGroup = JSON.parse(JSON.stringify(groupQuestions[0]));
      } catch (error) {      
        cloneEconomicGroup = [];
      }
  
      groupObject.idOperation = group.idOperation;
      groupObject.type = group.type;
      groupObject.isHead = group.questions.borrowerLegalPersonId === group.questions.economicGroupLegalPersonId;
      groupObject.personRelationshipExpireDate = groupQuestionAnswer.personRelationshipExpireDate;
      groupObject.memberOfEconomicGroup = group.memberOfEconomicGroup;
      groupObject.economicGroupLegalPersonId = groupQuestionAnswer.economicGroupLegalPersonId;
      groupObject.economicGroupApprovedLimit = groupQuestionAnswer?.economicGroupApprovedLimit;
      groupObject.hierarchyLevel = economicGroup.hierarchyLevel;
      let questions = cloneEconomicGroup.map(question => {
  
        if (question.idQuestion === 1837) {
          const answer = groupQuestionAnswer?.economicGroupPersonName || "";
  
          question.answer = answer;
          question.answerJson = answer;
        }
  
        if (question.idQuestion === 1694) {
          const answer = groupQuestionAnswer?.borrowerPersonName || "";
  
          question.answer = answer;
          question.answerJson = answer;
        }
  
        if (question.idQuestion === 1695) {
          const answer = groupQuestionAnswer?.borrowerLegalPersonId || "";
  
          question.answer = answer;
          question.answerJson = answer;
        }
  
        if (question.idQuestion === 1697) {
          const answer = groupQuestionAnswer?.consumedLimit || "0";
  
          question.answer = answer;
          question.answerJson = answer;
        }
  
        if (question.idQuestion === 1698) {
          const answer = groupQuestionAnswer?.draftedLimit || "0";
  
          question.answer = answer;
          question.answerJson = answer;
        }
  
        if (question.idQuestion === 1696) {
          const answer = groupQuestionAnswer?.approvedLimit || "0";
  
          question.answer = answer;
          question.answerJson = answer;
        }
  
        if (question.idQuestion === 1699) {
          const answer = groupQuestionAnswer?.availableLimit || "0";
  
          question.answer = answer;
          question.answerJson = answer;
        }
  
        if (question.idQuestion === 1700) {
          const answer = groupQuestionAnswer?.ccgLimit || "0";
  
          question.answer = answer;
          question.answerJson = answer;
        }
  
        if (question.idQuestion === 1701) {
          const answer = groupQuestionAnswer?.situationLimit || ""
  
          const foundQuestionOption = question.answerOptions.find(v => v.dsAnswerOption.trim() === answer.trim());
  
          if (foundQuestionOption) {
            question.answer = foundQuestionOption?.dsAnswerOption;
            question.answerJson = foundQuestionOption?.dsAnswerOption;
            question.idAnswerOption = foundQuestionOption?.idAnswerOption;
          }
        }
  
        if (question.idQuestion === 1851) {
          const idAnswerOption = groupQuestionAnswer?.usesProviderCCG ? 7462 : 7463;
          const answerOpt = question.answerOptions.find(
            opt => opt.idAnswerOption === idAnswerOption
          );
  
          if (answerOpt) {
            question.answer = answerOpt.dsAnswerOption;
            question.idAnswerOption = answerOpt.idAnswerOption;
          }
        }
  
        if (question.idQuestion === 1852) {
          const answer = groupQuestionAnswer?.consumeGroupLimit || ""
          const foundQuestionOption = question.answerOptions.find(v => v.dsAnswerOption.trim() === answer.trim());
  
          if (foundQuestionOption) {
            question.answer = foundQuestionOption?.dsAnswerOption;
            question.answerJson = foundQuestionOption?.dsAnswerOption;
            question.idAnswerOption = foundQuestionOption?.idAnswerOption;
          }
        }
  
        if (question.idQuestion === 2005) {
          question.answer = groupQuestionAnswer.personRelationshipCreateDate;
        }
  
        if (question.idQuestion === 2006) {
          question.answer = groupQuestionAnswer.personRelationshipExpireDate;
        }
  
        if (groupQuestionAnswer.personRelationshipExpireDate) {
          question.disabled = true;
        }
  
        return question;
      });
  
      const consumeGroupLimit = questions.find(qst => qst.idQuestion === 1852)?.idAnswerOption === 7465;
      if(economicGroup?.contextHierarchyChildren && consumeGroupLimit && !groupObject.isHead && isEconomicGroup){
        questions = questions.filter(qst => ![1696, 1700, 1699].includes(qst.idQuestion));
        groupObject.consumeGroupLimit = true;
      }
      groupObject.questions = questions;
      economicGroups.push(groupObject);
    }
    let hierarchyGroup = {
      hierarchyLevel: economicGroup.hierarchyLevel,
      contextHierarchyChildren: economicGroup.contextHierarchyChildren,
      contextHierarchyParent: economicGroup.contextHierarchyFather,
      headRelationshipExpired: economicGroup?.headRelationshipExpired,
      economicGroupRelationships: economicGroups
    }
    hierarchyGroups.push(hierarchyGroup);
  }

  setEconomicGroup(hierarchyGroups)
  setInitialEconomicGroup(hierarchyGroups)
  return hierarchyGroups;
}

async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
  token,
  globalQuestionnaire,
  updateIsLoadingStatus,
  handleCurrentExposure,
  handleChoiceOfConsumptionLimit,
  borrowerConsumption,
  mc
}) {
  let saveQuestionnaire = false;

  const isEconomicGroup = globalQuestionnaire.find((questionnaireAnswer) => questionnaireAnswer.idQuestion === 1830)?.idAnswerOption === 7415
  const borrowerName = globalQuestionnaire.find((questionnaireAnswer) => questionnaireAnswer.idQuestion === 1635)?.answer

  const fitinsurApi = new FitinsurAPI();

  let borrowerOperationId;

  if ((question.idQuestion === 1695 || question.idQuestion === 1694) && value?.idOperation) {
    updateIsLoadingStatus(true);
    saveQuestionnaire = true;
    fitinsurApi.setAuthToken(token);
    let response = await fitinsurApi.getBorrowerLimitsInfo(value.idOperation).then(v => v.json())

    updateIsLoadingStatus(false)

    if (response.statusCode != 200) return;

    const borrowerHierarchy = borrowerConsumption?.hierarchy;
    const borrowerInfo = response.value;
    borrowerOperationId = value.idOperation;
    
    const hierarchy = borrowerInfo?.hierarchy;

    const hierarchyLevel = borrowerHierarchy.currentLevel + hierarchy.totalLevel;

    if (hierarchyLevel > 3 || hierarchy.currentLevel !== 1) {
      mc && mc.error(`Limite hierárquico (nível 3) do tomador ${borrowerInfo?.borrowerLegalPersonId} atingido, portanto não foi possível associa-lo a esta analise de crédito.`);
      setFieldValue && setFieldValue(question.key, '');
      return
    }

    questionnaireUpdated = questionnaireUpdated.map((qst) => {
      if (qst.idQuestion === 1837) {
        const questionAnswer = isEconomicGroup ? (borrowerName || "") : (value.personLastName || "")

        qst.answer = questionAnswer
        qst.answerJson = questionAnswer;
        setFieldValue(qst.key, questionAnswer)
      }

      if (qst.idQuestion === 1694) {
        const questionAnswer = value.personLastName || ""

        qst.answer = questionAnswer
        qst.answerJson = questionAnswer;
        setFieldValue(qst.key, questionAnswer)
      }

      if (qst.idQuestion === 1695) {
        const questionAnswer = value?.legalPersonId || ""

        qst.answer = questionAnswer;
        qst.answerJson = questionAnswer;
        setFieldValue(qst.key, questionAnswer)
      }

      if (qst.idQuestion === 1696) {
        const questionAnswer = borrowerInfo?.approvedLimit || "0";

        qst.answer = questionAnswer;
        qst.answerJson = questionAnswer;
        setFieldValue(qst.key, questionAnswer)
      }

      if (qst.idQuestion === 1697) {
        const questionAnswer = borrowerInfo?.consumedLimit || "0";

        qst.answer = questionAnswer;
        qst.answerJson = questionAnswer;
        setFieldValue(qst.key, questionAnswer)
      }

      if (qst.idQuestion === 1698) {
        const questionAnswer = borrowerInfo?.draftedLimit || "0";

        qst.answer = questionAnswer;
        qst.answerJson = questionAnswer;
        setFieldValue(qst.key, questionAnswer)
      }

      if (qst.idQuestion === 1700) {
        const questionAnswer = borrowerInfo?.ccgLimit || "0";

        qst.answer = questionAnswer;
        qst.answerJson = questionAnswer;
        setFieldValue(qst.key, questionAnswer)
      }

      if (qst.idQuestion === 1701) {
        const questionAnswer = borrowerInfo?.situationLimit || "";

        const foundQuestionOption = qst.answerOptions.find(v => v.dsAnswerOption.trim() === questionAnswer.trim());

        if (foundQuestionOption) {
          qst.answer = foundQuestionOption?.dsAnswerOption;
          qst.answerJson = foundQuestionOption?.dsAnswerOption;
          qst.idAnswerOption = foundQuestionOption?.idAnswerOption;

          setFieldValue(qst.key, {
            dsAnswerOption: foundQuestionOption?.dsAnswerOption,
            idAnswerOption: foundQuestionOption?.idAnswerOption,
            resultValue: null
          })
        }
      }

      if (qst.idQuestion === 1851) {
        const idAnswerOption = borrowerInfo?.usesProviderCCG ? 7462 : 7463;
        const answerOpt = qst.answerOptions.find(
          opt => opt.idAnswerOption === idAnswerOption
        );

        if (answerOpt) {
          qst.answer = answerOpt.dsAnswerOption;
          qst.idAnswerOption = answerOpt.idAnswerOption;

          setFieldValue(
            qst.key,
            {
              dsAnswerOption: answerOpt.dsAnswerOption,
              idAnswerOption: answerOpt.idAnswerOption,
            }
          );
        }
      }

      return qst;
    })

    handleChoiceOfConsumptionLimit && handleChoiceOfConsumptionLimit(
      questionnaireUpdated,
      setQuestionnaire,
      borrowerOperationId,
      setFieldValue
    );

    handleCurrentExposure(borrowerInfo?.consumedLimit);
  }

  if (question.idQuestion === 1837 && value?.idOperation) {
    updateIsLoadingStatus(true);
    saveQuestionnaire = true;
    fitinsurApi.setAuthToken(token);
    let response = await fitinsurApi.getBorrowerLimitsInfo(value.idOperation).then(v => v.json())

    const borrowerInfo = response.value;

    updateIsLoadingStatus(false)

    if (response.statusCode != 200) return;
    borrowerOperationId = value.idOperation;
    
    const borrowerHierarchy = borrowerConsumption?.hierarchy;
    const headHierarchy = borrowerInfo?.hierarchy;

    const hierarchyLevel = headHierarchy.currentLevel + borrowerHierarchy.totalLevel - borrowerHierarchy.currentLevel;

    if (hierarchyLevel >= 3) {
      mc && mc.error(`Limite hierárquico (nível 3) do tomador ${borrowerInfo?.borrowerLegalPersonId} atingido, portanto não foi possível associa-lo a esta analise de crédito.`);
      setFieldValue && setFieldValue(question.key, '');
      return
    }

    questionnaireUpdated = questionnaireUpdated.map((qst) => {
      if (qst.idQuestion === 1837) {
        const questionAnswer = value.personLastName || "";

        qst.answer = questionAnswer
        qst.answerJson = questionAnswer;
        setFieldValue(qst.key, questionAnswer)
      }

      return qst;
    })

    handleChoiceOfConsumptionLimit && handleChoiceOfConsumptionLimit(
      questionnaireUpdated,
      setQuestionnaire,
      borrowerOperationId,
      setFieldValue
    );
  }

  if (saveQuestionnaire && borrowerOperationId) {
    setQuestionnaire(questionnaireUpdated, borrowerOperationId);
  }
}

function createSectionRow({ group, isHead, referenceDate }) {
  group = JSON.parse(JSON.stringify(group[0]));
  
  return {
    idOperation: null,
    type: isHead ? group.type : null,
    isHead: isHead,
    isNew: true,
    personRelationshipExpireDate: null,
    memberOfEconomicGroup: null,
    questions: group.questions.map(question => {
      const { defaultValue } = question.behaviorObject || {};

      if (!isHead) {
        if (question.idQuestion !== 1699) {
          question.answer = defaultValue || "";
          question.answerJson = defaultValue || "";
          question.idAnswerOption = null;
          question.idPerson = null;
          question.idQuestionnaireAnswers = null;
          question.idQuestionnaireAnswersParent = null;
          question.idQuestionnaireAnswersRoot = null;
          question.key = null;
        }

        if (question.idQuestion === 1695 || question.idQuestion === 1694) {
          question.behaviorObject.isReadOnly = false;
          question.disabled = false
        }

        if (question.idQuestion === 1699) {
          question.answer = group.questions.find(qst => qst.idQuestion === 1699)?.answer || "0";
          question.answerJson = group.questions.find(qst => qst.idQuestion === 1699)?.answer || "0";
        }

        if (question.idQuestion === 1852) {
          question.answer = "Sim";
          question.answerJson = "Sim";
          question.idAnswerOption = 7465;
        }

        if (question.idQuestion === 2005) {
          question.answer = referenceDate;
        }
      } else {
        if (question.idQuestion === 1837) {
          question.answer = defaultValue || "";
          question.answerJson = defaultValue || "";
          question.idAnswerOption = null;
          question.idPerson = null;
          question.idQuestionnaireAnswers = null;
          question.idQuestionnaireAnswersParent = null;
          question.idQuestionnaireAnswersRoot = null;
          question.key = null;
          question.behaviorObject.isReadOnly = false;
          question.disabled = false
        }
      }

      return question;
    }
    )
  }
}

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
  createSectionRow,
}

export { events };
